module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/router-1-85ad17865465ab1dbf31139cf37abcc8.svg";